'use client';
import { Quiz } from 'components/UI/Quiz';
import styles from './allergy-test.module.scss';
import data from './data';

const allergyResults = [
  {
    headline: 'Kaum Risiko',
    text: 'Du kannst dich glücklich schätzen, denn dein Risiko, eine Allergie zu entwickeln, ist eher gering. Wahrscheinlich lebst du ohnehin so, dass du dein Immunsystem nicht unnötig belastest und es mit einer ausgewogenen Ernährung und viel Bewegung stärkst. Einfach weiter so!',
  },
  {
    headline: 'Durchschnittliches Risiko',
    text: 'Dein Risiko, eine Allergie zu entwickeln, ist durchschnittlich. Du solltest auf eine gesunde Ernährung und viel Bewegung achten, damit du dein Immunsystem weiterhin stärkst. Ein zusätzlicher Tipp: Rauchen kann das Allergierisiko erhöhen, daher Finger weg vom Glimmstängel!',
  },
  {
    headline: 'Hohes Risiko',
    text: 'Dein Risiko, eine Allergie zu entwickeln, ist besonders hoch. Gerade wenn Allergien in der Verwandtschaft bekannt sind, ist dies wahrscheinlich, weil die Allergieneigung erblich bedingt sein kann. Achte darauf, dein Immunsystem nicht unnötig zu belasten und stärke es mit einer ausgewogenen Ernährung und viel Bewegung. Um sicher zu gehen, lasse sich dich in einer Allergologie-Praxis untersuchen. Außerdem solltest du von Tabakwaren Abstand halten, denn, ob passiv oder aktiv – Rauchen erhöht das Allergierisiko.',
  },
];

export const WidgetToolsCalculatorAllergyTest = () => {
  return (
    <Quiz
      data={data}
      startButtonText="Test starten"
      nextButtonText="nächste Frage"
      previousButtonText="vorherige Frage"
      calculateButtonText="Ergebnis berechnen"
      recalculateButtonText="Neu berechnen"
      calculateResult={(state) => {
        let totalScore = 0;
        state.answers.forEach((answer) => {
          totalScore += answer.points;
        });

        if (totalScore <= 4) {
          return allergyResults[0];
        } else if (totalScore <= 7) {
          return allergyResults[1];
        } else {
          return allergyResults[2];
        }
      }}
      renderResult={(_, calculatedResult) => {
        return (
          <>
            <div className={styles.resultTitle}>Testauswertung:</div>

            <div className={styles.resultHeadline}>{calculatedResult.headline}</div>

            <p>{calculatedResult.text}</p>
          </>
        );
      }}
    />
  );
};
